import React from "react";
import {
  FaReact,
  FaNodeJs,
  FaUbuntu,
  FaGithub,
  FaBootstrap,
} from "react-icons/fa";
import {
  SiExpress,
  SiJavascript,
  SiTypescript,
  SiHtml5,
  SiCss3,
  SiTailwindcss,
  SiFigma,
  SiMongodb,
} from "react-icons/si";
import "./Skills.css";
import SkillCard from "./SkillCard";
import { DiJqueryLogo } from "react-icons/di";

const Skills = () => {
  const skills = [
    { icon: <FaGithub />, label: "Github" },
    { icon: <DiJqueryLogo />, label: "JQuery" },
    { icon: <FaReact />, label: "React" },
    { icon: <FaNodeJs />, label: "Node.js" },
    { icon: <FaBootstrap />, label: "Bootstrap" },
    { icon: <SiExpress />, label: "Express.js" },
    { icon: <SiJavascript />, label: "JavaScript" },
    { icon: <SiTypescript />, label: "TypeScript" },
    { icon: <SiHtml5 />, label: "HTML" },
    { icon: <SiCss3 />, label: "CSS" },
    { icon: <SiTailwindcss />, label: "Tailwind CSS" },
    { icon: <SiFigma />, label: "Figma" },
    { icon: <SiMongodb />, label: "MongoDB" },
    { icon: <FaUbuntu />, label: "Ubuntu" },
  ];

  return (
    <div
      className="skills-page container-fluid bg-dark text-light py-5 d-flex align-items-center justify-content-center"
      style={{ minHeight: "100vh" }}
    >
      <div className="text-center">
        <h1 className="mb-5">Skills</h1>
        <div className="skills-grid d-flex flex-wrap justify-content-center">
          {skills.map((skill, index) => (
            <SkillCard key={index} icon={skill.icon} label={skill.label} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Skills;
